import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import { HLS_PLAYBACK } from '@/constants';

export interface SimuliveVideoRoomState {
  currentActiveSimuliveBroadcastID: string;
  hlsVideoElement: any;
  isHLSStreamingSupported: boolean;
  hLSContext?: any | null;
  hLSVideoSource: string;
  isFillerSlideVisible: boolean;
  videoPlaybackStallTimeout: null | ReturnType<typeof setTimeout>;
  videoPlaybackStallRestartTimeout: null | ReturnType<typeof setTimeout>;
  hasVideoPlaybackStalled: boolean;
  manifestLoadingErrorHandlerTimeout: null | ReturnType<typeof setTimeout>;
  networkErrorRetriesCount: number;
  fragsThatFailedLoading: any[];
  currentFragementPosition: number;
  videoPlaybackNudgeForwardTimeout: null | ReturnType<typeof setTimeout>;
  hlsConfig: any;
  isPlayingNatively: boolean;
  idealPlaybackEndTimestamp: number;
  intervalForCheckingVideoHasEnded: null | ReturnType<typeof setInterval>;
  inTestingMode: boolean;
  isHLSLevelLoadError: Boolean;
  isHLSManifestLoadError: Boolean;
  isHLSFragLoadError: Boolean;
  forceSwitchToNonInHouseSimulive: boolean;
  isSessionEnded: boolean;
  showOverlayCaptions: boolean;
  vttAvailableCaptions: any;
}

const state: SimuliveVideoRoomState = {
  currentActiveSimuliveBroadcastID: '',
  hlsVideoElement: document.createElement('video'),
  isHLSStreamingSupported: true,
  // hLSContext: null,
  hLSVideoSource: '',
  isFillerSlideVisible: true,
  videoPlaybackStallTimeout: null,
  videoPlaybackStallRestartTimeout: null,
  hasVideoPlaybackStalled: false,
  manifestLoadingErrorHandlerTimeout: null,
  networkErrorRetriesCount: 0,
  fragsThatFailedLoading: [],
  currentFragementPosition: 0,
  videoPlaybackNudgeForwardTimeout: null,
  hlsConfig: {
    // documented here for the current hls.js version we use:
    // https://github.com/video-dev/hls.js/blob/caa633f5578f8003327b355cbac5325b04be38e2/docs/API.md
    autoStartLoad: true,
    liveSyncDurationCount: 3,
    liveDurationInfinity: true,
    startFragPrefetch: true,
    fragLoadingMaxRetry: HLS_PLAYBACK.FRAG_LOAD_MAX_RETRIES,
    manifestLoadingMaxRetry: HLS_PLAYBACK.MANIFEST_LOAD_MAX_RETRIES,
    levelLoadingMaxRetry: HLS_PLAYBACK.LEVEL_LOAD_MAX_RETIRES,
    backBufferLength: 0,
    abrBandWidthUpFactor: 0.6,
    maxBufferLength: 60,
    maxMaxBufferLength: 120,
    liveMaxLatencyDurationCount: 8,
    initialLiveManifestSize: 2
  },
  isPlayingNatively: false,
  idealPlaybackEndTimestamp: 0,
  intervalForCheckingVideoHasEnded: null,
  inTestingMode: false,
  isHLSLevelLoadError: false,
  isHLSManifestLoadError: false,
  isHLSFragLoadError: false,
  forceSwitchToNonInHouseSimulive: false,
  isSessionEnded: true,
  showOverlayCaptions: true,
  vttAvailableCaptions: []
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
